module.exports = __webpack_public_path__ + "static/20150926_102255_resized-6867f9be60ad99cf86b407737c58b54e.jpg";